class CIPLighttouchBlock {
    constructor() {}

    getLightValue(lighttouchBlock) {
        if (!lighttouchBlock) {
            return {
                result: false,
                error: '[Error] The lighttouch block is not connected.',
            };
        }

        // lighttouchBlock.ledControl();

        return new Promise(resolve => {
            setTimeout(() => {
                const value = lighttouchBlock.getLightValue();
                resolve(value);
            }, 200);
        });
    }

    isButtonPress(lighttouchBlock) {
        if (!lighttouchBlock) {
            return {
                result: false,
                error: '[Error] The lighttouch block is not connected.',
            };
        }

        // lighttouchBlock.ledControl();

        return new Promise(resolve => {
            setTimeout(() => {
                const value = lighttouchBlock.isButtonPress();
                resolve(value);
            }, 200);
        });
    }
}

export default CIPLighttouchBlock;
